<template>
  <el-dialog
    :title="'设置企业管理员'"
    :visible.sync="visible"
    width="480px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="110px">
      <el-form-item
        label="员工姓名："
        prop="staffName">
        <el-input v-model="info.staffName"></el-input>
      </el-form-item>
      <el-form-item
        label="员工账号："
        prop="account">
        <el-input v-model="info.account"></el-input>
      </el-form-item>
      <el-alert
        :closable="false"
        title="员工账号请填入员工的微信手机号"
        type="warning">
      </el-alert>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditStaffModal',
  components: { },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        orgId: null,
        vendorName: '',
        account: '',
        staffName: '',
        userType: 100,
        isAdmin: 1
      },
      rules: {
        staffName: [
          { required: true, message: '请输入员工姓名', trigger: 'blur' },
          { max: 16, message: '员工姓名长度最多 16 个字符', trigger: 'blur' }
        ],
        account: [
          { required: true, message: '请输入企业员工账号（微信手机号）', trigger: 'blur' },
          { pattern: /^1[0-9][0-9]\d{8}$/, message: '请输入正确的企业员工账号（微信手机号）', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      const orgId = this.info.orgId
      return (orgId ? '设置' : '新增') + '企业管理员'
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        orgId: null,
        vendorName: '',
        account: '',
        staffName: '',
        userType: 100,
        isAdmin: 1
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.resetFields()
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch(`account/addstaff`, {
            payload: this.info,
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    update(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
